import { PropsWithChildren } from "react";
import "./BreakdownRow.scss";

const BreakdownRow = (props: PropsWithChildren) => (
  <div className="c-breakdown-row">{props.children}</div>
);

export default BreakdownRow;
